<script>
  import { editStore, imageStore } from '../stores';
  import features from '../components/features.js';
  import { t } from '../i18n';

  function selectFeature(feature) {
    $editStore.selectedFeature = feature;
  }
</script>

<div class="feature-list">
  {#each features as feature, i}
    <button
      type="button"
      class="feature-btn"
      class:selected={$editStore.selectedFeature && $editStore.selectedFeature.id === feature.id}
      on:click={() => selectFeature(feature)}
      aria-label={$t(`feature.${feature.id}`)}
      disabled={feature.disabled || (!$imageStore.uploadedImageUrl && feature.id !== 'upload_image')}
      class:disabled={feature.disabled || (!$imageStore.uploadedImageUrl && feature.id !== 'upload_image')}
    >
      <div class="icon-wrapper">
        <div class="circle-bg" aria-hidden="true"></div>
        <img
          src={feature.icon}
          alt=""
          class="feature-icon"
          class:orange-icon={feature.iconTone === 'orange'}
        />
      </div>
      <span class="feature-label">{$t(`feature.${feature.id}`)}</span>
    </button>
    {#if i === 0}
      <div class="feature-divider"></div>
    {/if}
  {/each}
</div>

<style>
  .feature-list {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ccc;
    overflow-y: auto;
    /* height: 100%; */
  }
  .feature-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.2rem;
    padding: 1rem;
    background: none;
    border: none;
    cursor: pointer;
    color: #585858;
  }
  .feature-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  .icon-wrapper {
    position: relative;
    width: 3rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .circle-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    border-radius: 50%;
  }
  .feature-icon {
    width: 2rem;
    height: 2rem;
    z-index: 1;
  }
  .feature-icon.orange-icon {
    filter: brightness(0) saturate(100%) invert(50%) sepia(73%) saturate(2291%) hue-rotate(347deg) brightness(99%) contrast(89%);
  }
  .feature-label {
    font-size: 0.8rem;
    color: #585858;
  }
  .feature-divider {
    height: 1px;
    background-color: #ccc;
    margin: 0.5rem 0;
  }
  .feature-btn:hover {
    border: none;
  }
  .feature-btn:hover .circle-bg {
    background-color: rgba(254, 106, 55, 0.4);
  }
  .feature-btn.disabled .circle-bg {
    background-color: #f5f5f5;
  }
  .feature-btn.selected,
  .feature-btn:active {
    border: none;
  }
  .feature-btn.selected .circle-bg,
  .feature-btn:active .circle-bg {
    background-color: #FE6A37;
  }
  .feature-btn.selected .feature-icon,
  .feature-btn:active .feature-icon {
    filter: brightness(0) invert(1);
  }
  .feature-btn.selected .feature-label,
  .feature-btn:active .feature-label {
    color: #FE6A37;
  }
  @media (max-width: 800px) {
    .feature-list { flex-direction: row; overflow-x: auto; border-right: 0; border-bottom: 1px solid #8883; }
    .feature-btn { flex: 0 0 82px; padding: 8px 5px; }
    .feature-divider { width: 1px; height: auto; flex: 0 0 1px; margin: 8px 0; }
  }
</style>
